import {
  minValue, required, useTranslate, InputProps, Validator,
} from 'react-admin';
import { InputLabel, Box } from '@mui/material';
import { expiryTimeGranularityType } from '../../../../lib/constants/selectChoices';
import { GrayNumberInputWithUpperLabel } from './GrayNumberInputWithUpperLabel';
import { GraySelectInputWithUpperLabel } from './GraySelectInputWithUpperLabel';
import { integer } from '../../../../utils/numberValidators';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export const GrayExpiryTimeGranularityInputWithUpperLabel = (props: InputProps & {
  validation?: Validator[];
  defaultNumberValue?: number;
  helperText?: string;
  isRequired?: boolean;
}) => {

  const translate = useTranslate();

  if (!props || !props.source) {

    return null;

  }
  const validation = props.validation || [required()];
  return (
    <Box>
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={props.helperText} />
      <Box sx={{ width: '100%' }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          alignItems: 'flex-start',
          width: '100%',
        }}>
          <Box sx={{ flex: 1 }}>
            <GrayNumberInputWithUpperLabel source={`${props.source}.value`} validate={[minValue(1), integer(), ...validation]}
              label={false}
              defaultValue={props.defaultNumberValue ?? 1}
              disabled={props.disabled || false}
              size={'small'}
              shouldUnregister
              helperText={false}
              sx={{
                width: '100%',
              }}/>
          </Box>
          <Box sx={{ flex: 4 }}>
            <GraySelectInputWithUpperLabel source={`${props.source}.type`} choices={expiryTimeGranularityType} validate={validation}
              defaultValue={props.defaultValue ?? 'month'}
              label={false}
              disabled={props.disabled || false}
              size={'small'}
              helperText={false}
              shouldUnregister
              sx={{
                width: '100%',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );

};
